import moment from "moment";

export const parseNoteDate = (date) => {
  const parsed = moment(date);

  if (parsed.isValid()) return parsed;

  return moment(date, "DD-MM-YYYY HH:mm");
};

export const formatNoteContent = (note) => {
  const date = note.startTime || note.created;
  const parsed = parseNoteDate(date);
  const formattedDate = parsed.isValid() ? parsed.format("DD-MM-YYYY") : "Date unknown";

  return `<p><strong>Consultation Note (${formattedDate}):</strong></p><p>${note.note || ""}</p><p>---</p>`;
};

export const formatPrescriptionContent = (prescription) => {
  const medications = prescription.medications || [];
  const medicationList =
    medications.length > 0
      ? medications
          .map((med) => {
            const name = med.tradeName || med.genericName || "N/A";
            const type = med.acuteLongTerm || med.usageType || "";
            const datePrescribed = med.prescribedDate || med.startDate;
            const details = [
              med.dosage ? `<strong>Dosage:</strong> ${med.dosage}` : null,
              med.form ? `<strong>Form:</strong> ${med.form}` : null,
              med.frequency ? `<strong>Frequency:</strong> ${med.frequency}` : null,
              med.route ? `<strong>Route:</strong> ${med.route}` : null,
              med.duration
                ? `<strong>Duration:</strong> ${med.duration}${med.durationFormat ? ` ${med.durationFormat}` : ""}`
                : null,
              med.quantity ? `<strong>Quantity:</strong> ${med.quantity}` : null,
              med.repeat ? `<strong>Repeats:</strong> ${med.repeat}` : null,
              datePrescribed
                ? `<strong>Date Last Prescribed:</strong> ${moment(datePrescribed).format("DD-MM-YYYY")}`
                : null,
              type ? `<strong>Type:</strong> ${type}` : null,
            ]
              .filter(Boolean)
              .join(" &nbsp;|&nbsp; ");
            return `<li><strong>${name}</strong>${details ? ` &mdash; <span style="font-size:13px">${details}</span>` : ""}</li>`;
          })
          .join("")
      : "<li>No medications</li>";

  return `<p><strong>Prescription (${moment(
    prescription.datePrescribed || prescription.created
  ).format("DD-MM-YYYY")}):</strong></p>
${prescription.note ? `<p><em>Note: ${prescription.note}</em></p>` : ""}
<p><strong>Medications:</strong></p>
<ul>${medicationList}</ul>
<p>---</p>
`;
};

const CERTIFICATE_TYPE_LABELS = {
  MED1: "Medical Certificate 1",
  MED2: "Medical Certificate 2",
};

const PHYSICAL_EFFORT_LABELS = {
  LIGHT: "Light",
  MODERATE: "Moderate",
  HEAVY: "Heavy",
  NOT_APPLICABLE: "Not Applicable",
};

export const formatLetterContent = (letter) => {
  const date = letter.documentCreated || letter.created;
  const formattedDate = date ? moment(date).format("DD-MM-YYYY") : "Date unknown";
  const title = letter.name || "Untitled Letter";

  return `<p><strong>Letter: ${title} (${formattedDate}):</strong></p>${letter.text || ""}<p>---</p>`;
};

export const formatCertificateContent = (certificate) => {
  const cert = certificate?.deaspCertificate;
  const messageControlId = certificate?.messageControlId ?? cert?.messageControlId;

  const doctor = cert?.dspPanelDoctor
    ? `${cert.dspPanelDoctor.firstName} ${cert.dspPanelDoctor.surname}`
    : null;

  const certType = CERTIFICATE_TYPE_LABELS[cert?.certFormType] ?? cert?.certFormType ?? null;
  const physicalEffort = PHYSICAL_EFFORT_LABELS[cert?.physicalEffortRequired] ?? cert?.physicalEffortRequired ?? null;

  const sickFrom = cert?.sickFromDate ? moment(cert.sickFromDate).format("DD-MM-YYYY") : null;
  const sickTo = cert?.sickToDate ? moment(cert.sickToDate).format("DD-MM-YYYY") : null;

  const lines = [
    doctor ? `<p><strong>Doctor:</strong> ${doctor}</p>` : "",
    certType ? `<p><strong>Certificate Type:</strong> ${certType}</p>` : "",
    cert?.natureOfConditionCode
      ? `<p><strong>Condition Code:</strong> ${cert.natureOfConditionCode}</p>`
      : "",
    cert?.natureOfCondition
      ? `<p><strong>Nature of Condition:</strong> ${cert.natureOfCondition}</p>`
      : "",
    sickFrom ? `<p><strong>Sick From:</strong> ${sickFrom}</p>` : "",
    sickTo ? `<p><strong>Sick To:</strong> ${sickTo}</p>` : "",
    cert?.finalCertIndicator
      ? `<p><strong>Is Final:</strong> ${cert.finalCertIndicator}</p>`
      : "",
    physicalEffort
      ? `<p><strong>Physical Effort Required:</strong> ${physicalEffort}</p>`
      : "",
    cert?.inHospital
      ? `<p><strong>Hospitalised:</strong> ${cert.inHospital}</p>`
      : "",
    messageControlId
      ? `<p><strong>Message Control ID:</strong> ${messageControlId}</p>`
      : "",
    certificate?.error_message
      ? `<p><strong>Error:</strong> ${certificate.error_message}</p>`
      : "",
  ]
    .filter(Boolean)
    .join("");

  return `<p><strong>DEASP Certificate:</strong></p>${lines}<p>---</p>`;
};
